module.exports = __webpack_public_path__ + "flyer_background_martini_3_097-8e0bee0436336dbcb54cd202e97f28be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_martini_3_097.jpg
// module id = 1661
// module chunks = 1